import React from 'react'

import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { Prompt } from 'react-router-dom'
import { appPublishRequest, appUnpublishRequest } from '../../actions'

import { Box, Column, Row } from 'components/Layout'
import { Form, FieldFooter, FormSection, FormError } from 'components/Form'
import { SaveButton } from 'components/Button'
import { BoxShell } from 'components/Shells'
import { Image } from 'components/Image'

import FieldSection from './FieldSection.js'
import { CHECKBOX } from './fieldTypes.js'

// import GoPublic from '../../assets/intros/marketplace.svg'
import goPublic from '../../assets/intros/guy-carry.png'
import { SubmissionListContainer } from '../../containers'

const AppDistributionForm = props => {
	const {
		dispatchSubmit,
		handleSubmit,
		submitting,
		dirty,
		app,
		isAppPublished,
		isAppAccepted,
		error
	} = props
	const fields = [
		{
			type: CHECKBOX,
			disabled: !isAppAccepted,
			name: 'appPublished',
			fieldId: 'appPublished',
			title: 'Make this app public (review required)',
			description:
				'This will make the app publicly discoverable and ready to install for all of the chat.io customers.'
		}
	]

	if (typeof app === 'undefined' || typeof isAppPublished === 'undefined') {
		return (
			<Form>
				<BoxShell height={180} />
				<BoxShell height={220} />
				<BoxShell height={120} />
			</Form>
		)
	}

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			<Prompt
				when={submitting || dirty}
				message={() =>
					`You've got unsaved changes. Are you sure you want to leave this page?`}
			/>
			<Box
				header={'For all other teams'}
				body={
					<span>
						<FormSection dark>
							<Row notPadded center>
								<Column width={2}>
									<Image
										src={goPublic}
										width={100}
										height={200}
									/>
								</Column>
								<Column>
									<p>
										Reach companies and chat.io users with
										your app!
									</p>
								</Column>
							</Row>
						</FormSection>

						<FormSection>
							<FieldFooter
								description={
									<span>
										Before your app becomes available for
										all chat.io customers it needs to go
										through a review process.
									</span>
								}
							/>
							<SubmissionListContainer appId={app.id} />
						</FormSection>
						<div>
							{fields.map(field => {
								return (
									<FieldSection
										{...field}
										key={field.fieldId}
									/>
								)
							})}
						</div>
					</span>
				}
				info={
					isAppAccepted || isAppPublished ? (
						<span>
							{!submitting ? <FormError error={error} /> : null}
							<SaveButton submitting={submitting} dirty={dirty} />
						</span>
					) : (
						''
					)
				}
			/>
		</Form>
	)
}

const mapStateToProps = (state, ownProps) => {
	const currentAppId = ownProps.match.params.appId
	const currentApp = state.apps.items[currentAppId]

	const isAppPublished = currentApp
		? currentApp.status === 'PUBLISHED'
		: false

	const isAppAccepted = currentApp ? currentApp.status === 'ACCEPTED' : false

	return {
		app: currentApp,
		isAppPublished,
		isAppAccepted,
		status: currentApp ? currentApp.status : '',
		initialValues: { appPublished: isAppPublished || false }
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		dispatchSubmit: values => {
			dispatch(
				values.appPublished
					? appPublishRequest({
							id: ownProps.match.params.appId,
							formName: 'appDistributionPublic',
							...values
						})
					: appUnpublishRequest({
							id: ownProps.match.params.appId,
							formName: 'appDistributionPublic',
							...values
						})
			)
		}
	}
}

const ConnectedAppDistributionForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: 'appDistributionPublic',
		touchOnBlur: false,
		enableReinitialize: true
	})(AppDistributionForm)
)

export default ConnectedAppDistributionForm



// WEBPACK FOOTER //
// ./src/containers/Forms/AppDistributionPublicForm.js